import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class BookingService {
  async fetch(page, perPage) {
    const response = await ajaxService.get(
      `/booking-schedules?page=${page}&perPage=${perPage}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewbooking(id) {
    const response = await ajaxService.get(`/booking-schedules/${id}`);
    if (response ?? false) {
      return response;
    }
    else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addbooking(data) {
    const response = await ajaxService.post(`/booking-schedules`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updatebooking(id, data) {
    const response = await ajaxService.put(`/booking-schedules/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deletebooking(id) {
    const response = await ajaxService.delete(`/booking-schedules/`, id);
    if (response ?? false) {
      return response;
    }
  }
}

const bookingService = new BookingService();

export default bookingService;
